import api from 'utils/api';
import { getAPIBase } from "utils/api/apiBase";
import { mapTracks, mapTrackPage } from './tracks.utils';

export const getTrackPage = async (trackId) =>
  api.get(`${getAPIBase()}/tracks/${trackId}/`).then((response) => mapTrackPage(response.data));

export const getTracks = async (trackAssetsIds) =>
  api
    .get(`${getAPIBase()}/tracks/?ids=${[...new Set(Object.values(trackAssetsIds))].join(',')}`)
    .then((response) => mapTracks(response.data, trackAssetsIds));
